export default {
  freeShipping: {
    title: 'Portes grátis',
    zoneLine: '{{zone}}: a partir de {{amount}}',
    achieved: 'Tem portes grátis!',
    remaining: 'Adicione mais {{amount}} para portes grátis para {{zone}}.',
  },
}
